import { ExpanderChevronPosition } from "./interfaces";
export var ExpanderContentDefaultProps = {
  topSpacing: 0,
  isExpanded: false,
  shouldAnimateImmediately: false
};
export var ExpanderDefaultProps = {
  chevronPosition: ExpanderChevronPosition.Leading,
  shouldExpandOnMount: false,
  contentSpacing: 'S300'
};